import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { FreightShipmentDialog } from 'src/modules/supply_chain/components/freight/ShipmentDialog'
import { skuit } from 'src/services/skuit'

import { FreightShipmentListTable } from 'src/components/Table/list/FreightShipment'
import { ListPage } from 'src/components/Pages/ListPage'

export const ShipmentListPage = () => {
  const paginator = useQueryPaginator('freight-shipment-list', skuit.sc.freight.shipments.list)

  const exportFields = [
    'address1',
    'address2',
    'canceled_on',
    'carrier_guid',
    'carrier_name',
    'city',
    'client_guid',
    'client_name',
    'consignee',
    'delivered_on',
    'facility_address1',
    'facility_address',
    'facility_city',
    'facility_guid',
    'facility_name',
    'facility_postal_code',
    'facility_state',
    'guid',
    'internal_notes',
    'order_guid',
    'order_number',
    'path',
    'place_guid',
    'postal_code',
    'shipped_on',
    'state',
    'status',
    'tracking_number',
  ]

  return (
    <ListPage
      title='Freight Shipments'
      paginator={paginator}
      dialogs={[{ title: 'New Freight Shipment', Dialog: FreightShipmentDialog }]}
    >
      <FreightShipmentListTable
        paginator={paginator}
        fields={['trackingNumber', 'client', 'consignee', 'facility', 'carrier', 'status']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.freight.shipments.export
        }}
        bulkActions={['bulkEdit']}
      />
    </ListPage>
  )
}
